import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  RedeemExchange as RedeemExchangeComponent,
  RedeemExchangeProps,
} from "../../components/RedeemExchange/RedeemExchange";
import { StoreState } from "../../reducers";
import { getExchangeId, getExchanges } from "../../reducers/methods";
import {
  exchangeRedeem,
  getExchangesAction,
  setScreenName,
} from "../../actions";

interface RedeemExchangeContainerProps extends RedeemExchangeProps {
  currency?: string;
  exchangeRedeem: typeof exchangeRedeem;
  exchanges: ReturnType<typeof getExchanges>;
  getExchangesAction: typeof getExchangesAction;
  selectedExchangeId: ReturnType<typeof getExchangeId>;
}

class RedeemExchange extends React.Component<RedeemExchangeContainerProps> {
  render() {
    const { exchanges = [] } = this.props;
    if (exchanges.length === 0) {
      this.props.getExchangesAction();
    }

    return <RedeemExchangeComponent {...this.props} />;
  }
}

function mapStateToProp(
  state: StoreState,
  props: RedeemExchangeContainerProps
): Pick<
  RedeemExchangeProps,
  | "exchanges"
  | "selectedExchangeId"
  | "isLoadingRedeemExchanges"
  | "originalEmail"
> {
  return {
    exchanges: getExchanges(state),
    selectedExchangeId: getExchangeId(state),
    isLoadingRedeemExchanges: state.exchange.isLoadingRedeemExchanges,
    originalEmail:
      get(props, "data.customer.originalEmail") || props.originalEmail,
  };
}

export default connect(mapStateToProp, {
  exchangeRedeem,
  getExchangesAction,
  setScreenName,
})(RedeemExchange);
